import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface FloodsProps {}

const Floods: FC<FloodsProps> = () => {
    const ctx = useContext(EditableCellCtx)

    return (
        <Form.Item name={'stampFloods'} noStyle>
            <InputNumber
                autoFocus
                controls={false}
                onBlur={() => {
                    ctx.onBlur()
                }}
            />
        </Form.Item>
    )
}

export default Floods
